module.exports = __webpack_public_path__ + "static/media/notification-icon.a35bdac0.svg";